import Divider from '@material-ui/core/Divider'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import DeleteIcon from 'assets/images/ui/icons/trash.svg'
import UpdateIcon from 'assets/images/ui/icons/edit.svg'
import {useEvent} from 'Event/EventProvider'
import {ObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/list'
import {useDeleteObieAttendeeLink} from 'lib/event-api/integrations/obie/attendee-links/delete'
import ConfirmDialog from 'lib/ui/ConfirmDialog'
import Icon from 'lib/ui/Icon'
import IconButton from 'lib/ui/IconButton'
import CopyIconButton from 'lib/ui/IconButton/CopyIconButton'
import Menu from 'lib/ui/Menu'
import MenuItem from 'lib/ui/Menu/MenuItem'
import {getEventUrl} from 'lib/url'
import AttendeeLinkDestination from 'organization/Event/Services/Apps/Obie/Config/AttendeeLinks/AttendeeLinkDestination'
import {useOrganization} from 'organization/OrganizationProvider'
import React from 'react'

export interface AttendeeLinkRowProps {
  link: ObieAttendeeLink
  obieHubId: string
  onEdit: () => void
}

export default function AttendeeLinkRow(props: AttendeeLinkRowProps) {
  const {link, obieHubId, onEdit} = props
  const {event} = useEvent()
  const {client} = useOrganization()
  const deleteLink = useDeleteObieAttendeeLink({client, event})

  const url = `${getEventUrl(event)}/obie/${link.slug}`

  return (
    <TableRow aria-label="attendee link">
      <TableCell>{link.label}</TableCell>
      <TableCell>{link.slug}</TableCell>
      <TableCell>
        <AttendeeLinkDestination link={link} obieHubId={obieHubId} />
      </TableCell>
      <TableCell align="right">
        <Menu
          button={({open}) => (
            <IconButton onClick={open} aria-label="view attendee link actions">
              <Icon className="fas fa-ellipsis-h" color="black" iconSize={18} />
            </IconButton>
          )}
        >
          <div>
            <MenuItem
              icon={UpdateIcon}
              aria-label="edit attendee link"
              disabled={deleteLink.isLoading}
              onClick={onEdit}
            >
              Edit
            </MenuItem>
            <Divider />
            <ConfirmDialog
              title="Remove this link?"
              description="Attendees who open this link will see an error."
              confirmLabel="Remove"
              variant="dangerous"
              onConfirm={() => deleteLink.mutate(link)}
            >
              {(confirm) => (
                <MenuItem
                  icon={DeleteIcon}
                  aria-label="remove attendee link"
                  disabled={deleteLink.isLoading}
                  onClick={confirm}
                >
                  Remove
                </MenuItem>
              )}
            </ConfirmDialog>
          </div>
        </Menu>
      </TableCell>
      <TableCell align="right">
        <CopyIconButton
          aria-label="copy attendee link"
          beforeCopyTooltip="Copy attendee link"
          onClick={() => navigator.clipboard.writeText(url)}
        />
      </TableCell>
    </TableRow>
  )
}
